<!-- DATA BOX -->
@if (transaction()) {
  <div class="shadow-lg mb-10 md:mb-0 px-4 md:px-6 py-2 md:py-4 box-white">
    <!-- Seats recap -->
    @for (seat of seatsByPrice(); track $index) {
      <h4 class="font-bold text-main-dark md:text-left text-center">
        <span class="underline">{{ seat.quantity }} Seats</span> x
        <span class="underline">{{
          transaction().transaction.buyerTypeName
        }}</span>
        at
        <span class="text-red">${{ seat.price | number: '1.2-2' }}</span>
      </h4>
    }

    <!-- Seats table -->
    <div class="mt-2 lg:mt-4 mb-7 lg:mb-10 w-full">
      <table class="w-full border-separate table-fixed">
        @for (section of seatsForTable(); track section.id) {
          <tr class="flex flex-wrap sm:flex-nowrap mb-3">
            <td class="mb-1 sm:mb-0 w-full md:w-16 td">
              <div class="flex justify-center items-center">
                <img
                  [priority]="false"
                  alt="main chair icon"
                  class="mr-1"
                  ngSrc="/assets/img/chair-blue-icon.svg"
                  height="12"
                  width="12" />
                <p class="font-bold text-main text-center">
                  {{ section.totalSectionSeats }}
                </p>
              </div>
            </td>
            <td
              class="flex justify-start md:justify-center md:items-center sm:mx-2 mb-1 sm:mb-0 w-full md:w-auto td">
              <p class="flex items-center">
                Section
                <span class="ml-2 font-bold text-main md:text-center">{{
                  section.id
                }}</span>
              </p>
            </td>
            <td class="p-0 w-full md:w-auto">
              @for (row of section.rows; track row.id) {
                <div class="flex td-lines">
                  <p class="mr-10">
                    Row<span class="ml-2 font-bold text-main">{{
                      row.id
                    }}</span>
                  </p>
                  <p>
                    Seats<span class="ml-2 font-bold text-main">{{
                      row.seatsRanges.join(', ')
                    }}</span>
                  </p>
                </div>
              }
            </td>
          </tr>
        }
      </table>
    </div>

    <!-- Cart summary -->
    <div class="lg:flex mb-7 md:mb-10 w-full">
      <div
        class="m-auto lg:pr-3 pb-3 border-gray-200 lg:border-r border-b lg:w-2/3">
        <div class="m-auto">
          <h5 class="mb-2 font-bold md:text-left text-center">
            Your adjusted seat amount is listed below:
          </h5>
          <div class="px-0 xs:px-20 sm:px-32 md:px-28 lg:px-0 text-gray-500">
            <div
              class="flex justify-between items-center mb-1 md:px-10 md:text-left text-center">
              <h5>Seats:</h5>
              <h5
                class="bg-main-off-white mt-1 md:ml-4 px-2 py-1 rounded-lg w-24 md:text-right">
                @if (
                  transaction().transaction.tdcTransaction?.totalPriceSeats
                ) {
                  ${{
                    transaction().transaction.tdcTransaction?.totalPriceSeats
                      | number: '1.2-2'
                  }}
                }
              </h5>
            </div>
            @if (isTicketFeeEnabled()) {
              @for (serviceCharge of serviceChargesDetails; track $index) {
                @if (serviceCharge.amount) {
                  <div
                    class="flex justify-between items-center mb-1 md:px-10 md:text-left text-center">
                    <h5 class="font-normal">{{ serviceCharge.name }}:</h5>
                    <h5
                      class="bg-main-off-white mt-1 md:mt-0 md:ml-4 px-2 py-1 rounded-lg w-24 md:text-right">
                      ${{ serviceCharge.amount | number: '1.2-2' }}
                    </h5>
                  </div>
                }
              }
            } @else {
              @if (transaction().transaction.tdcTransaction?.serviceCharges) {
                <div
                  class="flex justify-between items-center mb-1 md:px-10 md:text-left text-center">
                  <h5 class="font-normal">Per ticket fees:</h5>
                  <h5
                    class="bg-main-off-white mt-1 md:mt-0 md:ml-4 px-2 py-1 rounded-lg w-24 md:text-right">
                    ${{
                      transaction().transaction.tdcTransaction?.serviceCharges
                        | number: '1.2-2'
                    }}
                  </h5>
                </div>
              }
            }

            @if (
              transaction().transaction.tdcTransaction?.hasInsuranceRainout
            ) {
              <div
                class="flex justify-between items-center mb-1 md:mb-0 md:px-10 md:text-left text-center">
                <h5>
                  <span class="mr-1 font-normal">Insurance:</span>Rainout
                  Insurance:
                </h5>
                <h5
                  class="bg-main-off-white mt-1 md:mt-0 md:ml-4 px-2 py-1 rounded-lg w-24 md:text-right">
                  ${{
                    transaction().transaction.tdcTransaction
                      ?.insuranceRainoutPrice | number: '1.2-2'
                  }}
                </h5>
              </div>
            }
            @if (this.upgradesService.acquiredUpgrades) {
              <div>
                @for (
                  upgrade of this.upgradesService.acquiredUpgrades;
                  track upgrade.id
                ) {
                  <div
                    class="flex justify-end items-center mb-1 md:mb-0 md:text-left text-center">
                    <h5 class="text-right">
                      <span class="mr-1 font-normal">By purchasing</span
                      >{{ upgrade.goal }} tickets
                      <span class="inline-block mx-1 font-normal"
                        >you receive:</span
                      >{{ upgrade.name }}.
                    </h5>
                    <div class="min-w-max">
                      <h5
                        class="bg-main-off-white mx-auto mt-1 md:mt-0 md:ml-4 px-2 py-1 rounded-lg w-24 md:text-right">
                        BENEFIT
                      </h5>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <div class="lg:m-auto pt-3 lg:pl-3 lg:w-1/3">
        <div class="text-center">
          <h4 class="font-bold">Ticket Total:</h4>
          <h4 class="font-bold">
            @if (transaction().transaction.tdcTransaction?.balance) {
              ${{
                transaction().transaction.tdcTransaction?.balance
                  | number: '1.2-2'
              }}
            }
          </h4>
        </div>
      </div>
    </div>
  </div>
}
